import React, { useState } from 'react';
import pt from 'prop-types';
import { isNil } from 'lodash';

import { Box, Stack, Typography } from '@metarouter-private/mr-mui';

import RevisionSelect from './RevisionSelect';
import RevisionDiffViewer from './RevisionDiffViewer';

export default function CompareRevisions({ integration }) {
  const { playbooks } = integration;
  const [leftId, setLeftId] = useState(null);
  const [rightId, setRightId] = useState(null);

  const leftPlaybook = playbooks.find(playbook => playbook.id === leftId);
  const rightPlaybook = playbooks.find(playbook => playbook.id === rightId);
  const bothSelected = !isNil(leftPlaybook) && !isNil(rightPlaybook);

  return (
    <Box p={2}>
      <Stack spacing={3} padding={3}>
        <Stack direction="row" spacing={2}>
          <RevisionSelect
            label="Revision A"
            playbooks={playbooks}
            value={leftId}
            onChange={setLeftId}
            testId="revisionASelect"
          />
          <RevisionSelect
            label="Revision B"
            playbooks={playbooks}
            value={rightId}
            onChange={setRightId}
            testId="revisionBSelect"
          />
        </Stack>
        {bothSelected ? (
          <RevisionDiffViewer integration={integration} leftPlaybook={leftPlaybook} rightPlaybook={rightPlaybook} />
        ) : (
          <Typography variant="body2" color="secondary">
            Select two revisions to compare.
          </Typography>
        )}
      </Stack>
    </Box>
  );
}

CompareRevisions.propTypes = {
  integration: pt.object.isRequired,
};
